import { defineMessages } from 'react-intl';

export const identifiersMessages = defineMessages({
    identifiers: {
        id: 'identifiers',
        defaultMessage: 'Identifiers',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    value: {
        id: 'value',
        defaultMessage: 'Value',
    },
    validity: {
        id: 'validity',
        defaultMessage: 'Validity',
    },
    forever: {
        id: 'forever',
        defaultMessage: 'Forever',
    },
    oneTime: {
        id: 'one-time',
        defaultMessage: 'One time',
    },
    timeSensitive: {
        id: 'time-sensitive',
        defaultMessage: 'Time sensitive',
    },
    isUsed: {
        id: 'is-used',
        defaultMessage: 'Is used',
    },
});
